export default function formatPrice(price) {
  if (!price || !price?.currency || price?.amount === null) {
    return '';
  }
  const formatter = new Intl.NumberFormat('de-CH', { style: 'currency', currency: price.currency });

  return formatter.format(price.amount / 100);
}
